/**
 * Odessa stores a bank branch's `Name` as `<uuid>-<routingNumber>` (or `<business>-<uuid>`),
 * and only its `BankName` field holds something a customer would recognise. The upcoming-payment
 * feed carries the former, so whenever rose-portal-service cannot resolve a real name from
 * payment history the raw branch name reaches us instead (OPS-622).
 *
 * The check is deliberately narrow — an embedded UUID — so that legitimately terse names
 * such as "Chase" are never rejected.
 */
const BRANCH_NAME_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/**
 * Whether a value is safe to render as a bank name.
 *
 * @param value - The candidate bank name.
 * @returns `true` for a non-blank name that is not an Odessa bank-branch identifier.
 */
export function looksLikeBankName(value: string | null | undefined): value is string {
    return !!value?.trim() && !BRANCH_NAME_PATTERN.test(value);
}
